import IconButton from "../ui-components/IconButton";
import axios from "axios";
import NotesAttachementsUploader from "./NotesAttachementsUploader";
import {XMarkIcon} from "@heroicons/react/24/solid";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import ProgressBar from "./ProgressBar";
import {useState} from "react";

const NotesAttachmentsSection = ({
                                     worksiteId,
                                     noteAttachments,
                                     setNoteAttachments,
                                     disabled = false
                                 }
) => {


    const apiRequest = useCountryAxiosInstance();
    const [attachmentsBeingUploadedProgresses, setattachmentsBeingUploadedProgresses] = useState([]);

    return (
        <div>
            {noteAttachments.map((attachment, idx) => {
                return(
                    <div className="flex gap-2 items-center justify-start mb-1" key={idx}>
                        <a
                            style={{textDecoration: 'underline', cursor: 'pointer', color:'black'}}
                            href={attachment.attachment_url}
                            onClick={async (e)=>{
                                e.preventDefault()
                                const url = await apiRequest.post(`/aws-signed-url`, {
                                  content_type: '',
                                  format: '',
                                  name: attachment.filename,
                                  prefix: attachment.attachment_url.split(".com/").pop(),
                                  bucket: 'worksites_notes_attachments',
                                  method: 'GET'
                                });
                                const element = document.createElement("a");
                                element.href = url;
                                element.download = attachment.filename;
                                document.body.appendChild(element); // Required for this to work in FireFox
                                element.click();
                            }}
                        >{attachment.filename}
                        </a>
                        {!disabled &&
                        <IconButton
                            Icon={XMarkIcon}
                            className="w-1 h-1"
                            styleType="empty"
                            onClick={() => {
                                setNoteAttachments(noteAttachments.filter((_, i) => i !== idx));
                            }}
                        />}

                    </div>
                )
            })}
            {attachmentsBeingUploadedProgresses.map((attachmentBeingUploaded, idx) => {
                return (
                    <div className="flex gap-2 items-center justify-start mb-1" key={idx}>
                        <span>{attachmentBeingUploaded.filename}</span>
                        <ProgressBar progress={attachmentBeingUploaded.progress}></ProgressBar>
                    </div>);
            })}
            {!disabled &&
            <NotesAttachementsUploader
                worksiteId={worksiteId}
                noteAttachments={noteAttachments}
                setNoteAttachments={setNoteAttachments}
                attachmentsBeingUploadedProgresses={attachmentsBeingUploadedProgresses}
                setattachmentsBeingUploadedProgresses={setattachmentsBeingUploadedProgresses}
            />
            }
        </div>
    )
}

export default NotesAttachmentsSection;